import type { FC } from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { ApplicationConfigurationsValidationsView } from "src/app/features/ApplicationConfigurations/components/validations/ApplicationConfigurationsValidationsView";
import type { AppConfigsFieldEntity, AppConfigsTab } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import type { ExtendedColumnsType } from "../../../../../components";
import { PropertyTable } from "../../../../../components/Table/components/PropertyTable";

interface ApplicationConfigurationsPropertyTableProps {
    appConfigsTab: AppConfigsTab;
}

export const ApplicationConfigurationsPropertyTable: FC<ApplicationConfigurationsPropertyTableProps> = ({ appConfigsTab }) => {
    const { t } = useTranslation();

    const getColumnsConfig = useCallback(
        (): ExtendedColumnsType<AppConfigsFieldEntity>[] => [
            {
                title: t("dataGroups.appConfigs.hidden"),
                key: "name",
                dataIndex: "name",
                hidden: true,
            },
            {
                title: t("dataGroups.appConfigs.name"),
                key: "displayName",
                dataIndex: "displayName",
            },
            {
                title: t("dataGroups.appConfigs.component"),
                key: "component",
                dataIndex: "component",
            },
            {
                title: t("dataGroups.appConfigs.validations"),
                key: "validations",
                dataIndex: "validations",
                render: (_, record) => <ApplicationConfigurationsValidationsView value={record.validations} />,
            },
            {
                title: t("dataGroups.appConfigs.defaultValue"),
                key: "defaultValue",
                dataIndex: "defaultValue",
                render: (_, record) => {
                    const value = record.defaultValue?.value;
                    return value === undefined || value === null ? "" : String(value);
                },
            },
        ],
        [t],
    );

    return (
        <PropertyTable<AppConfigsFieldEntity>
            name={`${appConfigsTab.key}-property-table`}
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="index"
            tableData={appConfigsTab.configFields || []}
            readOnly={false}
            rowsAreSelectable={false}
            pagination={{
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
            }}
        />
    );
};
